import * as React from "react"
import {useEffect} from "react";
import {Grid} from "@mui/material";

import {HOME_ROUTES, MARKETPLACES_ROUTES} from "@constants";
import PageWrapper from "Pages/@PageWrapper"
import { TourProvider, TourTarget } from "@tour"
import { resetMarketplacesLostBuyBoxSignal, marketplacesLBBIsEmpty } from "./@signals";
import ProductPagesFilters from "./Filters";
import LostBuyBoxTable from "./Table";
import LostBuyBoxEvolutionChart from "./EvolutionChart";
import {isSystemBusy} from "../../../@signals";
import MarketplacesLBBReportFormDrawer from "./ReportForm";


export default function LostBuyBoxPage() {

    useEffect(() => {
        return () => resetMarketplacesLostBuyBoxSignal()
    }, [])

    return <PageWrapper
        head={`DIP Insight | ${MARKETPLACES_ROUTES.LBBDETAILS_SUBTITLE}`}
        title={MARKETPLACES_ROUTES.TITLE}
        subtitle={MARKETPLACES_ROUTES.LBBDETAILS_SUBTITLE}
        isEmpty={marketplacesLBBIsEmpty.value}
        filters={<ProductPagesFilters />}
        hasErrors={isSystemBusy.value}
        tourPageKey="lbbDetails"
    >
        <Grid container spacing={4}>
            <Grid item xs={12} id="table-details" sx={{ position: "relative" }}>
                <TourTarget name="lbb-details-table" height={350} />
                <LostBuyBoxTable />
            </Grid>

            <Grid item xs={12}>
                <LostBuyBoxEvolutionChart />
            </Grid>
        </Grid>
        <MarketplacesLBBReportFormDrawer />
    </PageWrapper>
}